/*
 * Purpose : Common component to create inputs to a form depends on passed props
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React, { Component } from 'react'
import { Form, FormGroup, Label, Input, Col, InputGroup, InputGroupAddon, FormFeedback } from 'reactstrap';
import './FormBuilder.css';
import { requiredFields, multiRowSections, validations } from './../../config/form-input-definition';
import { errorConstants, fileKeys } from './../../config/constants'
import { FaPlusCircle } from 'react-icons/fa'
import { MdClose } from 'react-icons/md';
//const fetch = require('node-fetch');
//const urlS3 = "https://excess-equip-file-storage34817-eqppoc.s3.amazonaws.com/public/dtp021-%24kg1t1qr4.jpg?AWSAccessKeyId=ASIASVPRIJNLO5OOL2HY&Expires=1602511944&Signature=%2F0NJv%2BTnj5bYZV3Tr9cv10U%2FS6Y%3D&x-amz-security-token=IQoJb3JpZ2luX2VjEFYaCXVzLWVhc3QtMSJIMEYCIQDZiYv1EZH1XDbC0inIg2EuOKHCxqzJEWKDeGvvCAuDGwIhAKiAdmk4nFBCSfr4KdpY9VTWqjOOVT7DhUPvXO8RhWcoKtMBCI%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMMTgzNTc4OTM4MTk4IgygzfPfJ5zDSpGyWOUqpwFsDXkYpK63RQMU4d6%2FmZXoCF1n9nTr8N%2FYB8d2iHbalY%2BCyjwT%2BLVTj4kwwrNU%2BpikM7oy1knDRPqFA61Q4glQjrPqQC6%2F%2FAc54NYoxXUUPA%2BrVF%2F0mSrBjAsXYxJBLLbEhytkVJwdiJJaq45G2LZivIZ8Zkef24U2bEy27wr1sJuaoYpVV8zDO5J4bWuUvTkSIqol5W2xJLvt6rbEzuEJWyBcpF2BODDCwZH8BTrfAd0Xmw13Cm%2Fp9VM3zjbSy37q3sYobdXcn35hWE5WWZ4PG%2BD2qkjal5mre6y8q3CwQymTZhAonrm3AvuMLFSqHp3wfB8WanZDYyyIL8UlPJwGd202vh8F7c8uuP4vVu82xW1oB5DJou5TvKcYtwoR0I6W6S6Kl7v%2BX%2BbcYtE7HkMJvNvkwmrV%2BXkYlB4cuBKcj9ZS4PZQVZS17mdAnpmNKYOi8elLUwEWtaGeCYDMauMDLpPuKU2ONMDUWsLhfRC5kNIluYtkq4LTFnYc%2Fgl9Fuic87r5CnZvVBUs6yBNzw4%3D";

export default class FormBuilder extends Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            missing: [],
            errorMsg: "",
            error: false,
            missingErrors: {},
            warningErrors: {}
        }
        this.items = []
        this.error = false
        this.missing = []
        this.missingErrors = {}
        this.data = props.data
        this.values = this.props.formValues
        this.newRows = this.props.newRows
        //console.log("new Rows="+this.newRows)
        this.toolfilenames = {}
        this.locations = [...this.props.locations]
        this.fabs = [...this.props.txnFabs]
        this.modules = [...this.props.txnModules]
        this.txnUemsEqptIdList = [...this.props.txnUemsEqptIdList]

        this.buildComponent = this.buildComponent.bind(this)
        this.handleTextChange = this.handleTextChange.bind(this)
        this.validateAndSend = this.validateAndSend.bind(this)
        this.handleDateChange = this.handleDateChange.bind(this)
        this.handleSelectChange = this.handleSelectChange.bind(this)
        this.handleNumberChange = this.handleNumberChange.bind(this)
        this.handleFileChange = this.handleFileChange.bind(this)
        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this)
        this.addSystemRow = this.addSystemRow.bind(this)
        this._arrayBufferToBase64 = this._arrayBufferToBase64.bind(this);
        this.deletePhoto = this.deletePhoto.bind(this);
    }

    componentWillMount() {
       // alert("componentWillMount")
        this.buildComponent()
    }
    componentWillUpdate() {
        //alert("componentWillUpdate")
        this.buildComponent()
    }
    componentWillReceiveProps(props) {
        this.missing = [...props.missingFields]
        this.locations = this.props.locations instanceof Array && [...this.props.locations]
        this.fabs = this.props.txnFabs instanceof Array && [...this.props.txnFabs]
        this.modules = props.txnModules instanceof Array && [...props.txnModules]
        this.txnUemsEqptIdList = props.txnUemsEqptIdList instanceof Array && [...props.txnUemsEqptIdList]
        this.buildComponent()
    }

    componentDidMount() {
        if (this.newRows && this.newRows instanceof Array) {
            for (let row of this.newRows) {
                if (row.count > 0 && { ...this.data }.items.filter(item => item.key === row.key).length > 0) {
                    for (let i = 0; i < row.count; i++) {
                        this.addSystemRow(undefined, row.key)
                    }
                }
            }
        }
    }

    // to build the input depends on the received props
    buildComponent = () => {
        const items = []
        try {
            if (this.data.header) {
                items.push(
                    <div className="header" key={this.data.header}>
                        <h4>{this.data.header} </h4>
                    </div>
                )
            }
            else{
                items.push(
                    <div className="header" key="main">
                        <h4>Transaction Details</h4>
                    </div>
                )
            }
            const fileHandlerArr = [];
            if (this.data.items && this.data.items instanceof Array) {
               // alert("entered main loop "+this.data.key)
                items.push(<br key={1} />)
                items.push(<br key={2} />)
                //const fileHandlerArr = [];
                this.data.items.forEach((item, index) => {
                    if (item.label) {   
                        this.frameFormInputs(item, items)
                    }
                    else if (item.legend !== undefined && item.items && item.items instanceof Array) {
                        let subItems = []
                        const rows = []
                        let legend = ""
                        let addRow = ""
                        if (item.legend !== "") {
                            legend = <legend>{item.legend}</legend>
                            addRow = <div><FaPlusCircle className={"add-row"} key={item.key} size="24" onClick={(val) => this.addSystemRow(val, item.key)} /></div>
                        }
                        if(item.legend === 'configfileslegend') {
                            legend = <div><div className={"headerLegend"}><h4 > Additional Tool Data Files</h4></div> <legend>Required Data - Detail Tool Configuration, OEM quotation/packing list, Tool Schematic, Tool acceptance, ...etc </legend></div>
                        }
                        item.items.forEach((row, i) => {
                            subItems = []
                            row.forEach(subitem => {
                                if (subitem.label) {
                                    this.frameFormInputs(subitem, subItems)
                                }
                                else {
                                    throw new Error("value not defined")
                                }
                                const splitItemName = subitem.name.split("-");
                                if (splitItemName[0] === 'photos' && splitItemName[2] === 'files') {
                                    const fileName = subitem.name.substring(0, subitem.name.lastIndexOf("-"));
                                    let toolPictures = {};
                                    Object.keys(this.values).forEach(key => {
                                        if (key.indexOf(fileName) !== -1 && this.values[key]) {
                                            toolPictures[key] = (this.values[key]);
                                        }
                                    })
                                        const fileArr = [];      // contains the file object which will updated in the state.
                                        const thumbnails = [];   // contains the details of already uploaded photos.
                                        Object.keys(toolPictures).forEach(async (e, i) => {
                                            const fileObj = {}  // Object containing details related to a specific picture like name, mime type etc;
                                            fileKeys.forEach((elm, j) => {
                                                if (j === 0 && e.indexOf(elm) !== -1) {
                                                    fileObj[elm] = toolPictures[e];
                                                }
                                                else if (e.indexOf(fileKeys[0]) !== -1) {
                                                    fileObj[elm] = toolPictures[e.replace(fileKeys[0], elm)]
                                                }
                                            });
                                            if (Object.keys(fileObj).length > 0) {
                                                let fileName = fileObj.toolfilename.indexOf("-$") !== -1 ? fileObj.toolfilename.replace(fileObj.toolfilename.substr(fileObj.toolfilename.indexOf("-$"),10),"") : fileObj.toolfilename;
                                                if (splitItemName[1] !== 'configfiles'){
                                                    const buff = this._arrayBufferToBase64(fileObj.toolpicture.data);
                                                    thumbnails.push(
                                                        <div>
                                                            <div className={"img-wrap"}>
                                                                <img key={i} src={`data:image/jpg;base64,${buff}`} alt="problem in loading tool" width="100" height="100" />
                                                                <MdClose className={"close"} onClick={() => this.deletePhoto(e, subitem.name)} />
                                                            </div>
                                                            <div>
                                                                {/* <p key={i}>{fileObj.toolfilename}</p> */}
                                                                <p key={i}>{fileName}</p>
                                                            </div>
                                                        </div>
                                                    ); 
                                                }else{
                                                    const byteArray = new Uint8Array(fileObj.toolpicture.data)
                                                    const blob = new Blob([byteArray], { type: fileObj.MimeType })
                                                    const url = window.URL.createObjectURL(blob)
                                                    thumbnails.push(
                                                        <div>
                                                            <div className={"img-wrap"}>
                                                            {/* <a key={i} href={url} download={fileObj.toolfilename} > {fileObj.toolfilename} </a>  */}
                                                            <a key={i} href={url} download={fileName} > {fileName} </a>
                                                            <MdClose className={"close"} onClick={() => this.deletePhoto(e, subitem.name)} />
                                                            </div>
                                                        </div>
                                                    );  
                                                }
                                                // const response2 = await fetch(urlS3);
                                                // const buffer2 = await response2.buffer();
                                                // console.log("buffer==>",buffer2)
                                                
                                                // const file = new File([new Uint8Array(fileObj.toolpicture.data)], fileObj.toolfilename, { type: fileObj.mimetype });
                                                const file = new File([new Uint8Array(fileObj.toolpicture.data)], fileObj.toolfilename, { type: fileObj.mimetype });
                                                fileArr.push(file);
                                                // console.log("file==>",file)
                                                // console.log("length==>",fileArr.length)
                                            }
                                        });
                                        if (fileArr.length) {
                                            const mockEvent = {};
                                            mockEvent.name = subitem.name;
                                            mockEvent.files = fileArr;
                                            fileHandlerArr.push({ ...mockEvent });
                                            subItems.push(<div className={"thumbnails-div"}>{thumbnails}</div>)
                                        }
                                }
                            })
                            rows.push(
                                <Form style={{ "width": "100%" }} inline key={i}>
                                    {subItems}
                                </Form>
                            )
                        })
                        items.push(
                            <div style={{width:"95%", marginLeft:"5%"}}>
                            <FormGroup row key={index}>
                                {multiRowSections.includes(this.data.key) ? addRow : ''} {legend?legend:<div className={"headerLegend"}><h4 > Additional Tool Data Files</h4></div>}
                                {rows}
                            </FormGroup>
                            </div>
                        )
                    }
                    else {
                        throw Error("items not defined")
                    }
                })
                if ((this.data.key === "photos") && fileHandlerArr.length) {
                    this.props.handleFileChange(fileHandlerArr);
                }
                this.items = items
            } else {
                this.error = true
            }
        }
        catch (err) {
            this.error = true
            console.log(err);
        }
    }

    addSystemRow = (e, key) => {
        try {
            const data = { ...this.data }
            const currentItem = data.items.filter(item => item.key === key)
            if (currentItem.length > 0) {
                if (currentItem.length !== 1) {
                    throw new Error("Legend type not unique")
                }
                const mainRow = [...{ ...currentItem[0] }.items.filter(item => {
                    return item[0].name.split('_').length === 1
                })][0]
                const newRow = []
                mainRow.forEach(item => {
                    const newItem = { ...item }
                    newItem.name += "_" + currentItem[0].items.length
                    newRow.push(newItem)
                })
                currentItem[0].items.push(newRow)
                data.items.map(item => {
                    if (item.key === key) {
                        return currentItem
                    }
                    else {
                        return item
                    }
                })
                this.data = data
                this.setState({
                    ...this.state,
                    error: false
                })
            }
        }
        catch (err) {
            this.error = true
            this.setState({
                ...this.state,
                error: this.error
            })
        }
    }
    // to handle text input changes
    handleTextChange = (e) => {
        const regExp = /[$]/
        let failed = false
        if (e.target.value) {
            failed = regExp.test(e.target.value)
        }
        if (this.validateAndSend(e, "", failed, errorConstants.charinvalid)) {
            this.props.handleTextChange(e)
        }
    }
    // to handle date input changes
    handleDateChange = (e) => {
        if (this.validateAndSend(e)) {
            this.props.handleDateChange(e)
        }
        // let date = document.getElementById('transaction-date').value;
        // let toolAvailableDate = document.getElementById('transaction-toolavailabledate').value;
        // let selectedDate;
        // let selectedToolAvailableDate;
        // if(date && toolAvailableDate){
        //     date = date.split('-');
        //     toolAvailableDate = toolAvailableDate.split('-');
        //     selectedDate=new Date();
        //     selectedDate.setFullYear(date[0],(date[1] - 1 ),date[2]);
        //     selectedToolAvailableDate=new Date();
        //     selectedToolAvailableDate.setFullYear(toolAvailableDate[0],(toolAvailableDate[1] - 1 ),toolAvailableDate[2]);     
        //     console.log(e)
        //     if (selectedDate > selectedToolAvailableDate)
        //     {
        //         alert("Tool Available Date should not be less than form Date");
        //         //document.getElementById('transaction-toolavailabledate').value
        //         e.target.value = "";
        //         return false;
        //     }
        // }
    }
    
    // to handle dropdown input changes
    handleSelectChange = (e) => {
        if (this.validateAndSend(e, "...")) {
            this.props.handleSelectChange(e)
        }
    }

    // to handle file input changes
    handleFileChange = (e) => {
        if (this.validateAndSend(e)) {
            this.props.handleFileChange(e)
        }
    }

    // to handle number input changes
    handleNumberChange = (e) => {
        const regExp = /^\d+$/
        let warnMsg = errorConstants.incorrectnumber
        let failed = false
        if (e.target.value) {
            failed = !regExp.test(parseInt(e.target.value, 10))
        }
        if (!failed) {
            if (validations[e.target.name]) {

                if (validations[e.target.name].regexp) {
                    const regex = new RegExp('^' + validations[e.target.name].regexp + '$')
                    failed = !regex.test(e.target.value)

                    if (failed) {
                        warnMsg = validations[e.target.name].error
                    }
                }
            } else if(e.target.name === 'general-vintage'){
                var yr = new Date().getFullYear();
                if(e.target.value < 1985 || e.target.value > yr){
                    warnMsg = 'Please enter year between 1985 and ' + yr;
                    failed = true;
                }
            }
        }
        if (this.validateAndSend(e, "", failed, warnMsg)) {
            this.props.handleNumberChange(e)
        }
    }

    // to handle checkbox input changes
    handleCheckBoxChange = (e) => {
        this.values[e.target.name] = e.target.checked
        this.props.handleCheckBoxChange(e)
    }

    // to check the text input value for validations and to add default values to required fields
    validateAndSend = (e, defaultVal, failed = false, warnMsg = "") => {
        try {
            let missing = this.missing
            if ((requiredFields.includes(e.target.name) && (e.target.value === undefined || e.target.value === defaultVal)) || failed || e.target.value.length >= 250) {
                if (!missing.includes(e.target.name)) {
                    missing.push(e.target.name)
                }
                if (failed) {
                    this.missingErrors[e.target.name] = warnMsg
                }
                else if (e.target.value.length >= 250) {
                    this.missingErrors[e.target.name] = "Field length exceeded 250 char limit. Anything after 250 chars will be truncated."
                }
                else {
                    this.missingErrors[e.target.name] = ""
                }

                if (e.target.name === "transaction-txnfab" && (e.target.value === undefined || e.target.value === defaultVal || e.target.value === "NA" ) )  {
                    this.modules = ["...","NA"]
                    this.txnUemsEqptIdList = ["...","NA","Not available from UEMS"]
                }
                if (e.target.name === "transaction-txnmodule" && (e.target.value === undefined || e.target.value === defaultVal || e.target.value === "NA" ) )  {
                    this.txnUemsEqptIdList = ["...","NA","Not available from UEMS"]
                }

                this.missing = missing                
                this.setState({
                    missing,
                    missingErrors: this.missingErrors,
                })
                return false
            }
            else {
                if (missing.includes(e.target.name)) {
                    missing.splice(missing.indexOf(e.target.name), 1)
                    this.missing = missing
                    this.setState({
                        missing
                    })
                }
                this.values[e.target.name] = e.target.value
                return true
            }
        }
        catch (err) {
            this.error = true
            this.setState({
                ...this.state,
                error: this.error
            })
            return false
        }
    }

    render() {
        return (
            <div className={"main"} key={"main-" + this.data.header}>
                {this.items}
                {this.error ? <div>Error loading form component</div> : ''}
            </div>
        )
    }

    frameFormInputs = (item, items) => {
        try {
            const required = requiredFields.includes(item.name) ? true : false
                //console.log(this.state.warningErrors)
            switch (item.type) {
                case "text": {
                    items.push(
                        <div style={{paddingLeft: "2%",paddingRight: "2%" }} >
                            <FormGroup row key={item.name}>
                                <Label for={item.name} sm={3}>{item.label}&nbsp;&nbsp;{required ? <b style={{ "color": "red" }}>*</b> : <p style={{width:"10px"}}></p> } </Label>
                                <Col sm={8} >
                                    <Input
                                        type={item.type}
                                        name={item.name}
                                        id={item.name}
                                        //placeholder={"Enter " + item.label + "..."}
                                        onBlur={this.handleTextChange}
                                        invalid={this.missing.includes(item.name) ? true : false}
                                        defaultValue={this.values[item.name] ? this.values[item.name] : ''}
                                        maxLength={254} />
                                    {this.missing.includes(item.name) ? <FormFeedback>{this.missingErrors[item.name]}</FormFeedback> : ''}
                                    {item.info ? <font className={"small-info"}> {item.info} </font> : ''}
                                </Col>
                            </FormGroup>
                        </div>
                    )
                    break;
                }
                case "date": {
                    let today = new Date();
                    const dd = String(today.getDate()).padStart(2, '0');
                    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                    const yyyy = today.getFullYear();
                    today = yyyy + '-' + mm + '-' + dd;
                    let selectedDate = '';
                    if(this.values[item.name]){
                        selectedDate = new Date(this.values[item.name]);
                        const dd1 = String(selectedDate.getDate()).padStart(2, '0');
                        const mm1 = String(selectedDate.getMonth() + 1).padStart(2, '0'); //January is 0!
                        const yyyy1 = selectedDate.getFullYear();
                        selectedDate = yyyy1 + '-' + mm1 + '-' + dd1;
                    }
                    items.push(
                        <div style={{paddingLeft: "2%",paddingRight: "2%" }} >
                            <FormGroup row key={item.name}>
                                <Label for={item.name} sm={3}>{item.label}&nbsp;&nbsp;{required ? <b style={{ "color": "red" }}>*</b> : ''}</Label>
                                <Col sm={8}>
                                    <Input
                                        type={item.type}
                                        min ={today}
                                        max={ item.name==="transaction-date"? today :"" }
                                        name={item.name}
                                        id={item.name}
                                        onChange={this.handleDateChange}
                                        invalid={this.missing.includes(item.name) ? true : false}
                                        onKeyDown={(e) => e.preventDefault()}
                                        //by soban
                                        //defaultValue={this.values[item.name] ? this.values[item.name] : ''} />
                                        //defaultValue={this.values[item.name] ? selectedDate : ''} />
                                        defaultValue={item.name === "transaction-date" ? today : selectedDate} />
                                    {item.info ? <font className={"small-info"}> {item.info} </font> : ''}
                                </Col>
                            </FormGroup>
                        </div>
                    )
                    break;
                }
                case "checkbox": {
                    items.push(
                        <div style={{paddingLeft: "2%",paddingRight: "2%" }} >
                            <FormGroup check key={item.name}>
                                <Label for={item.name} sm={3}>{item.label}&nbsp;&nbsp;{required ? <b style={{ "color": "red" }}>*</b> : ''}</Label>
                                <Col sm={9}>
                                    <Input
                                        type={item.type}
                                        name={item.name}
                                        id={item.name}
                                        onChange={this.handleCheckBoxChange}
                                        defaultChecked={this.values[item.name] ? true : false} />&nbsp; OK {item.info ? <font className={"small-info"}> {item.info} </font> : ''}
                                </Col>
                            </FormGroup>
                        </div>
                    )
                    break;
                }
                case "file": {
                    items.push(
                        <div style={{paddingLeft: "2%",paddingRight: "2%" }} >
                            <FormGroup row key={item.name}>
                                <Label for={item.name} sm={3}>{item.label}&nbsp;&nbsp;{required ? <b style={{ "color": "red" }}>*</b> : ''}</Label>
                                <Col sm={7}>
                                    <Input
                                        type={item.type}
                                        name={item.name}
                                        id={item.name}
                                        multiple
                                        accept={item.accept}
                                        //onChange={ item.name ==="photos-configfiles-files" ? this.handleConFileChange : this.handleFileChange}
                                        onChange={ this.handleFileChange}
                                        invalid={this.missing.includes(item.name) ? true : false} />
                                    {item.info ? <font className={"small-info"}> {item.info} </font> : ''}
                                </Col>
                                <hr sm={10}  />
                            </FormGroup>
                        </div>
                    )
                    break;
                }
                case "select": {                    
                    if(item.name==="transaction-location"){	
                        console.log("this.locations==>",this.locations instanceof Array && this.locations.length)
                        item.values = this.locations
                    }
                    if(item.name==="transaction-txnfab"){
                        console.log("this.fabs==>",this.fabs instanceof Array && this.fabs.length)
                        item.values = this.fabs
                    }
                    if(item.name==="transaction-txnmodule"){
                        console.log("this.modules==>",this.modules instanceof Array && this.modules.length)
                        //console.log("this.values[item.name] module ==> ",this.values[item.name])
                        this.modules.length === 0 ? item.values = [this.values[item.name]] : item.values = this.modules
                        
                    }
                    if(item.name==="transaction-txnuemseqptid"){
                        console.log("this.uemseqptid==>",this.txnUemsEqptIdList instanceof Array && this.txnUemsEqptIdList.length)                        
                        //console.log("this.values[item.name] uems id ==> ",this.values[item.name])
                        this.modules.length === 0 ? item.values = [this.values[item.name]] : item.values = this.txnUemsEqptIdList
                    }
                    
                    const options = []
                    if (item.values && item.values instanceof Array) {
                        item.values.forEach((option, index) => {
                            options.push(<option key={index}>{option}</option>)
                        })
                        items.push(
                            <div style={{paddingLeft: "2%",paddingRight: "2%" }} >
                                <FormGroup row key={item.name}>
                                    <Label for={item.name} sm={3}>{item.label}&nbsp;&nbsp;{required ? <b style={{ "color": "red" }}>*</b> : ''}</Label>
                                    <Col sm={8}>
                                        <Input
                                            type="select"
                                            name={item.name}
                                            id={item.name}
                                            onChange={this.handleSelectChange}
                                            invalid={this.missing.includes(item.name) ? true : false}
                                            defaultValue={this.values[item.name] ? this.values[item.name] : ''}>
                                            {options}
                                        </Input>
                                        {item.info ? <font className={"small-info"}> {item.info} </font> : ''}
                                    </Col>
                                </FormGroup>
                            </div>
                        )
                    }
                    else {
                        throw Error("values not defined")
                    }
                    break;
                }
                case "radio": {
                    if (item.values && item.values instanceof Array) {
                        const radios = []
                        item.values.forEach((radio, index) => {
                            radios.push(<Input key={index} type="radio" name={item.name} value={radio} id={item.name} onChange={this.props.handleRadioChange} />)
                            radios.push(<font key={index}>{radio}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</font>)
                        })
                        items.push(
                            <div style={{paddingLeft: "2%",paddingRight: "2%" }} >
                                <FormGroup row key={item.name}>
                                    <Label for={item.name} sm={3}>{item.label}&nbsp;&nbsp;{required ? <b style={{ "color": "red" }}>*</b> : ''}</Label>
                                    <Col key={item.name} sm={8}>
                                        {radios}
                                        {item.info ? <font className={"small-info"}> {item.info} </font> : ''}
                                    </Col>
                                </FormGroup>
                            </div>
                        )
                    }
                    else {
                        throw Error("values not defined")
                    }
                    break;
                }
                case "addon-number": {
                    items.push(
                        <div style={{paddingLeft: "2%",paddingRight: "2%" }} >
                            <FormGroup row key={item.name}>
                                <Label for={item.name} sm={3}>{item.label}&nbsp;&nbsp;{required ? <b style={{ "color": "red" }}>*</b> : ''}</Label>
                                <Col sm={8}>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">{item.addon}</InputGroupAddon>
                                        <Input
                                            type="number"
                                            name={item.name}
                                            id={item.name}
                                            //placeholder={"Enter " + item.label + "..."}
                                            onBlur={this.handleNumberChange}
                                            invalid={this.missing.includes(item.name) ? true : false}
                                            defaultValue={this.values[item.name] ? this.values[item.name] : ''} />
                                        {item.info ? <font className={"small-info"}> {item.info} </font> : ''}
                                    </InputGroup>
                                </Col>
                            </FormGroup>
                        </div>
                    )
                    break;
                }
                case "number": {
                    items.push(
                        <div style={{paddingLeft: "2%",paddingRight: "2%" }} >
                            <FormGroup row key={item.name}>
                                <Label for={item.name} sm={3}>{item.label}&nbsp;&nbsp;{required ? <b style={{ "color": "red" }}>*</b> : ''}</Label>
                                <Col sm={8}>
                                    <Input
                                        type="number"
                                        name={item.name}
                                        id={item.name}
                                        //placeholder={"Enter " + item.label + "..."}
                                        onBlur={this.handleNumberChange}
                                        invalid={this.missing.includes(item.name) ? true : false}
                                        defaultValue={this.values[item.name] ? this.values[item.name] : ''} />
                                    {this.missing.includes(item.name) ? <FormFeedback>{this.missingErrors[item.name]}</FormFeedback> : ''}
                                    {item.info ? <font className={"small-info"}> {item.info} </font> : ''}
                                </Col>
                            </FormGroup>
                        </div>
                    )
                    break;
                }
                default: {
                    break;
                }
            }
        }
        catch (err) {
            console.log(err)
            this.error = true
            this.setState({
                ...this.state,
                error: this.error
            })
        }
    }
    _arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }
    deletePhoto(photoItemIndex, sectionName) {
        this.props.handleFileRemove(photoItemIndex, sectionName);
    }
}